import { Component, OnInit, Input, Output } from '@angular/core';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { DetalheColeta } from '../../comum/modelos/detalhe-coleta';
import { ColetaService } from '../coleta.service';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';

@Component({
	selector: 'app-detalhe-coletas',
	templateUrl: './detalhe-coletas.component.html',
	styleUrls: ['./detalhe-coletas.component.css']
})
export class DetalheColetasComponent implements OnInit {

	@Input() resultadoColeta: ResultadoColeta;
	@Input() resultadoCriterioColeta: ResultadoCriterioColeta;

	detalhesColeta: DetalheColeta[];

	statusCode: number;
	public loading = false;

	constructor(private _coletaService: ColetaService) {
		this.detalhesColeta = new Array<DetalheColeta>();
	}

	ngOnInit() {
		const result = this.resultadoColeta;
		result.pesquisaComFoto = true;
		this._coletaService.obterDetalhesColetasHttp(result)
			.subscribe(detalhesColeta => {
				detalhesColeta.body.forEach(detalheColeta => {
					if (detalheColeta.criterioAvaliacao.nomeCriterioAvaliacao === this.resultadoCriterioColeta.nomeCriterioAvaliacao) {
						detalheColeta.coleta.foto = 'https://s3-sa-east-1.amazonaws.com/flag-static-bucket/' + detalheColeta.coleta.foto;
						this.detalhesColeta.push(detalheColeta);
					}
				});
			});
	}
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/detalhe-coletas/detalhe-coletas.component.ts